import { render, staticRenderFns } from "./ManualArticleSearch.vue?vue&type=template&id=61819a03"
import script from "./ManualArticleSearch.vue?vue&type=script&lang=js"
export * from "./ManualArticleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports